import {ECpmCUserTypeApiEnum} from '../../enums/cpmc-sdk.api-enums';
import {CpmCUserApiModel} from '../../models/c-global/cpmc-user.api-model';

/**
 * Utils for class CpmCUserApiModel
 */
export abstract class CpmCUserApiUtils {
    /**
     * Tell if an User type have super admin privileges
     * @param _type Type of user
     * @returns True if the type have super admin privileges
     */
    public static has_user_type_super_admin_privileges(_type?: ECpmCUserTypeApiEnum): boolean {
        if (!_type) {
            return false;
        }
        switch (_type) {
            case ECpmCUserTypeApiEnum.SUPER_ADMIN:
            case ECpmCUserTypeApiEnum.SUPER_ADMIN_M2M:
                return true;
        }

        return false;
    }
    /**
     * Tell if an User type is a machine to machine type
     * @param _type Type of user
     * @returns True if the type is a machine to machine type
     */
    public static is_user_type_a_machine_to_machine(_type?: ECpmCUserTypeApiEnum): boolean {
        if (!_type) {
            return false;
        }
        switch (_type) {
            case ECpmCUserTypeApiEnum.SUPER_ADMIN_M2M:
            case ECpmCUserTypeApiEnum.M2M:
                return true;
        }

        return false;
    }

    // ===============================================================
    // ===============================================================

    /**
     * Tell if this User have super admin privileges
     * @param instance User instance
     * @returns True if the User have super admin privileges
     */
    public static has_super_admin_privileges(instance?: CpmCUserApiModel): boolean {
        if (!instance) {
            return false;
        }

        return CpmCUserApiUtils.has_user_type_super_admin_privileges(instance.type);
    }
    /**
     * Tell if this User is a machine to machine type
     * @param instance User instance
     * @returns True if this User is a machine to machine type
     */
    public static is_user_as_machine_to_machine_user(instance?: CpmCUserApiModel): boolean {
        if (!instance) {
            return false;
        }

        return CpmCUserApiUtils.is_user_type_a_machine_to_machine(instance.type);
    }
}
